import { Notification, MessageBox } from 'element-ui';

function notify(type, text) {
    Notification({
        title: '提示',
        message: text,
        type,
        duration: 2000
    });
}

export default {
    success(text) {
        notify('success', text);
    },
    warning(text) {
        notify('warning', text);
    },
    info(text) {
        notify('info', text);
    },
    error(text) {
        notify('error', text);
    },
    ask(text, confirmCall) {
        MessageBox({
            title: '提示',
            message: text,
            showCancelButton: true,
            callback: action => {
                if (action === 'confirm') {
                    confirmCall && confirmCall();
                }
            }
        });
    }
}
